module.exports = __webpack_public_path__ + "img/malaysia.0c61421f.svg";